export default "__VITE_ASSET__C0Et2t4s__"